import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/danielwong/facility-calcom/cal2/apps/web/modules/apps/[slug]/slug-view.tsx");
